angular.module('TetherApp').controller('FormController', [
    function () {

        let fieldBaseUrl = '/html/experience/form-field/';

        let fieldInfo = {
            label: 'label.html',
            text: 'text.html',
            radio: 'radio.html',
            checkbox: 'checkbox.html',
            datepicker: 'datepicker.html',
            textarea: 'textarea.html',
            select: 'select.html'
        };

        this.fields = [
            {
                id: '1',
                type: 'label',
                templateUrl: fieldBaseUrl + fieldInfo['label']
            }
        ];

        this.update = function (field) {
            field.templateUrl = fieldBaseUrl + fieldInfo[field.type];
        };

        this.addField = function () {
            let newItemNo = this.fields.length + 1;
            this.fields.push({
                'id': newItemNo,
                type: 'label',
                templateUrl: getTemplate('label')
            });
        };

        this.removeField = function () {
            let lastItem = this.fields.length - 1;
            if (lastItem != 0) {
                this.fields.splice(lastItem);
            }
        };

    }
]);
